import { render, staticRenderFns } from "./PortalSelectionPage.vue?vue&type=template&id=42bb166a&"
import script from "./PortalSelectionPage.vue?vue&type=script&lang=js&"
export * from "./PortalSelectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports